import { FunctionComponent, useEffect, useState } from "react";
import { createPortal } from "react-dom";

import PmcPrivacyBanner from "@voxmedia/duet-ui/components/navigation/Footer/components/PmcPrivacyBanner";

/**
 * Sitewide PMC privacy notice for the hub. Portaled to `document.body` so
 * the fixed mosaic stage (`transform`) cannot trap `position: fixed`.
 *
 * Mount once at hub root — do not gate on credits. Deferring until the
 * closing slide hid the consent notice for the whole read.
 */
const HubPrivacyBanner: FunctionComponent = () => {
  const [root, setRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setRoot(document.body);
  }, []);

  if (root == null) {
    return null;
  }

  return createPortal(<PmcPrivacyBanner />, root);
};

export default HubPrivacyBanner;
